import React, { useEffect, useState } from "react";
import { sub, format } from "date-fns";
import "../styles/components/CurrentWeek.scss";

const CurrentWeek: React.FC = () => {
  const [currentWeek, setCurrentWeek] = useState<string[]>([]);

  useEffect(() => {
    setCurrentWeek([]);

    for (let i = 0; i < 7; i++) {
      setCurrentWeek((prev) => [
        ...prev,
        format(sub(new Date(), { days: i }), "dd MMM"),
      ]);
    }
  }, []);

  return (
    <div className="current-week">
      <ul className="current-week--container">
        {currentWeek.map((date, index) => {
          return (
            <li className={`current-week--day current-week--${index}`}>
              {date}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default CurrentWeek;
